module.exports = __webpack_public_path__ + "img/appStore.4a493b50.png";